import { Card, Modal } from "antd";
import styled from "styled-components";

// Card contenedor similar a Users
export const WrapperCardSauces = styled(Card)`
  display: flex;
  width: 100%;
  height: auto;
  text-align: left;
  font-weight: 400;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5715;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  border: 1px solid #f0f0f0;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  background: #fff;
  border-radius: 1rem !important;
  min-height: 100%;

  .ant-card-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

// Modal tipo popup para crear/editar salsa
export const DrawerSauces = styled(Modal)`
  & .ant-modal-content {
    border-radius: 16px;
  }

  & .ant-modal-header {
    border-radius: 16px 16px 0 0;
  }

  & .ant-modal-footer {
    display: none;
  }
`;
